import { Modal } from "flowbite-react";
import React, { useEffect, useState } from "react";
import { pdfjs, Document, Page } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
// import 'pdfjs-dist/build/pdf.worker.entry';
import { FaDownload } from "react-icons/fa";
import CommonApi from "../../Api/CommonApi";
import { toast } from "react-toastify";
import { SendEmailRequest } from "../../Models/SendEmailRequest";
import { useAppSelector } from "../../Reducers/store";
import { MdEmail, MdPrint, MdDownload } from "react-icons/md";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

export default function ViewReportModal({
  show,
  setShow,
  url,
  fileName,
  blob,
}: {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  url: string;
  fileName: string;
  blob: Blob | null;
}) {
  const { userModel } = useAppSelector((state) => state.user);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [numPages, setNumPages] = useState<number>(1);
  const [pageNumber, setPageNumber] = useState(1);

  function onDocumentLoadSuccess({ numPages }: { numPages: number }): void {
    setNumPages(numPages);
  }

  const downloadPdfNow = async () => {
    try {
      const tempLink = document.createElement("a");
      tempLink.href = url;
      tempLink.setAttribute("download", `${fileName}.pdf`);
      document.body.appendChild(tempLink);
      tempLink.click();

      document.body.removeChild(tempLink);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading PDF:", error);
    }
  };
  const sendEmailNow = async () => {
    if (userModel) {
      const arrayBuffer = await new Response(blob).arrayBuffer();
      const request: SendEmailRequest = {
        toEmail: userModel.emailAddress ?? "",
        subject: fileName,
        body: "",
        fileName: fileName,
        fileBlobString: _arrayBufferToBase64(arrayBuffer),
      };
      console.log(request);
      CommonApi.emailReport(request)
        .then((res) => {
          if (res.data.success) {
            toast.success("Email Sent");
          } else {
            toast.error("Error: " + res.data.message);
          }
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
          toast.error("Error");
          setIsLoading(false);
        });
    }
  };

  function _arrayBufferToBase64(buffer: ArrayBuffer) {
    let binary = "";
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }

  function onCloseModal() {
    setShow(false);
  }

  return (
    <>
      <Modal show={show} size="4xl" onClose={onCloseModal} popup>
        <Modal.Header></Modal.Header>
        <Modal.Body>
          <div className="flex justify-center gap-4">
            <button
              onClick={downloadPdfNow}
              className="flex gap-2 border rounded-md hover:bg-gray-100 p-2"
            >
              <MdDownload size={25} />
              <span>Download/Print</span>
            </button>
            <button
              onClick={sendEmailNow}
              className="flex gap-2 border rounded-md hover:bg-gray-100 p-2"
            >
              <MdEmail size={25} />
              <span>Email</span>
            </button>
          </div>
          <Document file={url} onLoadSuccess={onDocumentLoadSuccess}>
            <Page pageNumber={pageNumber} className="" />
          </Document>
          <div className="">
            <button
              disabled={pageNumber <= 1}
              onClick={() => setPageNumber(pageNumber - 1)}
              type="button"
              aria-label="Previous page"
              className="px-2 enabled:hover:bg-gray-200 rounded font-bold"
            >
              ‹
            </button>
            <span>
              {pageNumber} of {numPages}
            </span>
            <button
              disabled={pageNumber >= numPages}
              onClick={() => setPageNumber(pageNumber + 1)}
              type="button"
              aria-label="Next page"
              className="px-2 enabled:hover:bg-gray-200 rounded font-bold"
            >
              ›
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
